import * as React from 'react';
import './Popup.scss'
import {AnimatePresence, motion} from 'framer-motion'

export default function Popup({isOpen, handleClose, title, scrollable = false, containerId, children}: {isOpen: boolean, handleClose: Function, title?: string, scrollable?: boolean, containerId?: string, children: any}) {
    return (
        <>
            <AnimatePresence>
                {isOpen &&
                    <motion.div
                        initial={{opacity: 0}}
                        animate={{opacity: 0.4}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.15, type: 'ease'}}
                        key="full-background"
                        id="full-background"
                        onClick={() => handleClose()}
                    />
                }
            </AnimatePresence>

            <AnimatePresence>
                {isOpen &&
                    <motion.div
                        initial={scrollable ? {opacity: 0, transform: 'translate3d(-50%,30%,0) scale(0.7)'} : {opacity: 0, transform: 'translate3d(-50%,-20%,0) scale(0.7)'}}
                        animate={scrollable ? {opacity: 1, transform: 'translate3d(-50%,0%,0) scale(1)'} : {opacity: 1, transform: 'translate3d(-50%,-50%,0) scale(1)'}}
                        exit={scrollable ? {opacity: 0, transform: 'translate3d(-50%,30%,0) scale(0.7)'} : {opacity: 0, transform: 'translate3d(-50%,-20%,0) scale(0.7)'}}
                        transition={{duration: 0.35, ease: [0.52, 1.56, 0.59, 1.01] }}
                        key="popup-container"
                        className={`popup-container ${scrollable ? 'scrollable' : ''}`}
                        id={containerId}
                    >
                        <div className="popup-header">
                            <h2 className="popup-header-title">{title}</h2>
                            <button className="popup-header-close" onClick={() => handleClose()}>
                                <svg viewBox="0 0 386.667 386.667"><path d="m386.667 45.564-45.564-45.564-147.77 147.769-147.769-147.769-45.564 45.564 147.769 147.769-147.769 147.77 45.564 45.564 147.769-147.769 147.769 147.769 45.564-45.564-147.768-147.77z"/></svg>
                            </button>
                        </div>

                        {children}

                    </motion.div>
                }
            </AnimatePresence>
        </>


    )
}
